import { observable } from 'mobx';
import { HttpClient } from './HttpClient';

export class CommonAppStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @observable
    public headerHeight: number | null = null;

    @observable
    public titleContainer: HTMLDivElement | null = null;

    @observable
    public subTopbarContainer: HTMLDivElement | null = null;

    @observable
    public loadGoogleMaps = false;

    @observable
    public googleMapsLoaded = false;

    // Live Charts auto-scale by default (#20): axes fit the data, grouped per unit (#18). Static scaling
    // pins each axis to the display's configured bounds; it is opt-in from the Live Charts top bar.
    @observable
    public liveChartStaticScaling = false;

    @observable
    public chartHasDataOutOfBounds = false;

    private readonly httpClient: HttpClient;
}
